import { ethers } from "ethers";
import accountsData from '../../../static/data/accounts.json'

export const AUTH_LOGIN_ACTION = 'auth/Login';
export const AUTH_LOGOUT_ACTION = 'auth/Logout';
export const AUTH_LOGIN_ACTION_FAIL = 'auth/LoginFail';
export const AUTH_ACCOUNT_CHANGED = 'auth/account_changed';
export const AUTH_NETWORK_CHANGED = 'auth/network_changed';
export const AUTH_LOAD_ACCOUNT_ACTION = 'auth/load_account';
export const AUTH_LOAD_ACCOUNT_FAILED_ACTION = 'auth/load_account_failed';

const initialState = {
    account: '0x',
    loggedIn: false,
    permissions: [],
    walletType: null,
    network_chainId: null,
    network_name: null,
    provider: null,
    signer: null,
    wallet: {
        balance: 0
    },
    error: ''
};

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case AUTH_LOGIN_ACTION:
        case AUTH_LOAD_ACCOUNT_ACTION:
            return {...state, account: action.account, walletType: action.walletType, network_chainId: action.network_chainId, network_name: action.network_name, provider: action.provider, permissions: action.permissions, wallet: action.wallet, signer: action.signer, loggedIn: true, error: false };
        case AUTH_LOGOUT_ACTION:
            return {...state, ...initialState, wallet: { balance: 0 } };
        case AUTH_LOGIN_ACTION_FAIL:
            return {...state, account: initialState.account, permissions: initialState.permissions, loggedIn: false, error: 'failed to connect account' };
        case AUTH_ACCOUNT_CHANGED:
            return {...state, account: action.account, permissions: action.permissions, wallet: action.wallet, error: false };
        case AUTH_NETWORK_CHANGED:
            return {...state, network_name: action.network_name, network_chainId: action.network_chainId, wallet: action.wallet };
        case AUTH_LOAD_ACCOUNT_FAILED_ACTION:
        default:
            return state;
    }
}

const getWallet = async(account) => {
    let wallet = initialState.wallet;
    const provider = await new ethers.providers.Web3Provider(window.ethereum, "any");
    const balance = await provider.getBalance(account);
    wallet.balance = await ethers.utils.formatEther(balance);
    return wallet;
}

const getAccountData = async(provider) => {
    const accounts = await provider.send("eth_requestAccounts", []);
    const account = await ethers.utils.getAddress(accounts[0]);
    const permissions = await getAccountPermitions(account);
    const wallet = await getWallet(account);
    return { account, permissions, wallet };
}

const getWeb3 = async() => {
    let web3Obj = {
        connected: window.ethereum.isConnected(),
        provider: null,
        signer: null,
        connection: null,
        chainId: null
    };
    if (web3Obj.connected) {
        const provider = await new ethers.providers.Web3Provider(window.ethereum, "any");
        web3Obj.provider = provider;
        const signer = await provider.getSigner();
        web3Obj.signer = signer;
        web3Obj.chainId = parseInt(await window.ethereum.request({ method: 'eth_chainId' }), 16);
        const { connection } = web3Obj.provider;
        web3Obj.connection = connection;
    }
    return web3Obj;
}

const getAccountPermitions = address => {
    const acc = accountsData.find(acct => acct.address === address);
    return acc ? acc.permissions : [];
}

export const ActionLoadAccount = async(dispatch) => {
    const web3 = await getWeb3();
    const { connected, provider, signer, connection, chainId } = web3;
    if (!connected) {
        return dispatch({ type: AUTH_LOAD_ACCOUNT_FAILED_ACTION });
    }
    const accountData = await getAccountData(provider);
    const { account, permissions, wallet } = accountData;
    return dispatch({ type: AUTH_LOAD_ACCOUNT_ACTION, walletType: connection.url, network_name: '', network_chainId: chainId, account, provider, signer, permissions, wallet });
}

export const ActionLogin = async(dispatch) => {
    try {
        const web3 = await getWeb3();
        const { provider, signer, connection } = web3;
        const accountData = await getAccountData(provider);
        const { account, permissions, wallet } = accountData;
        const { _network } = provider;
        return dispatch(account && connection && _network ? {
            type: AUTH_LOGIN_ACTION,
            walletType: connection.url,
            network_name: _network.name,
            network_chainId: _network.chainId,
            account,
            provider,
            signer,
            permissions,
            wallet
        } : {
            type: AUTH_LOGIN_ACTION_FAIL
        });
    } catch (error) {
        return dispatch({ type: AUTH_LOGIN_ACTION_FAIL, error })
    }

};
export const ActionAccountChanged = async(dispatch, account) => {
    const wallet = await getWallet(account);
    const permissions = await getAccountPermitions(ethers.utils.getAddress(account));
    return dispatch({ type: AUTH_ACCOUNT_CHANGED, account, permissions, wallet });
}
export const ActionNetowrkChanged = async(dispatch, account, network) => {
    const wallet = await getWallet(account);
    return dispatch({ type: AUTH_NETWORK_CHANGED, network_name: network.name, network_chainId: network.chainId, wallet });
};
export const ActionLogout = { type: AUTH_LOGOUT_ACTION };